import { graphql } from "@server/gql";

export const getCartQuery = graphql(/* GraphQL */ `
  query getCart($cartId: String!, $locale: String!) {
    cart(cartId: $cartId, locale: $locale) {
      ...cart
    }
  }
`);
